import classNames from "classnames";
import { Button } from "@/components";
import type { ApiAsset } from "../../_types/assets.types";
import { AssetListItem } from "./AssetListItem.comp";
import styles from "./AssetsList.module.scss";

type AssetsListProps = {
  items: ApiAsset[];
  formatBytes: (n: number) => string;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  onDuplicate: (asset: ApiAsset) => void;
  onRequestDelete: (asset: ApiAsset) => void;
  actionsDisabled: boolean;
};

export const AssetsList = ({
  items,
  formatBytes,
  isLoading,
  isFetching,
  isError,
  onRetry,
  onDuplicate,
  onRequestDelete,
  actionsDisabled,
}: AssetsListProps) => {
  if (isLoading) {
    return (
      <div className={styles["comp__state"]}>
        <div className={styles["comp__spinner"]} />
        <div>Loading assets…</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles["comp__state"]}>
        <div>Could not load assets.</div>
        <Button size="small" variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className={styles["comp__state"]}>
        {isFetching ? "Updating…" : "No assets yet. Upload a file to get started."}
      </div>
    );
  }

  return (
    <div className={styles["comp"]} aria-busy={isFetching}>
      <div className={styles["comp__table-header"]}>
        <div className={styles["comp__column"]}>Name</div>
        <div className={styles["comp__column"]}>Kind</div>
        <div className={styles["comp__column"]}>MIME</div>
        <div className={styles["comp__column"]}>Size</div>
        <div className={classNames(styles["comp__column"], styles["comp__column--actions"])}>Actions</div>
      </div>

      <div className={styles["comp__list"]}>
        {items.map((asset) => (
          <AssetListItem
            key={asset.id}
            asset={asset}
            formatBytes={formatBytes}
            onDuplicate={() => onDuplicate(asset)}
            onDelete={() => onRequestDelete(asset)}
            actionsDisabled={actionsDisabled}
          />
        ))}
      </div>
    </div>
  );
};
